import { connect } from 'react-redux';
import ThemesPage from '../ThemesPage';
import { checkPermission, checkPlanPermission } from '../../../utils/ProfileHelpers';
import { setAction as setAppAction } from '../../../redux/actions/app';
import { setAction, getTeamThemes } from '../actions/themesPage';

const mapStateToProps = (state) => {
  return {
    paths: state.app.paths || {},
    team: state.profile.team,
    division: state.profile.division,
    divisions: state.profile.divisions,
    page: state.themesPage.page,
    pageSize: state.themesPage.pageSize,
    pageCount: state.themesPage.pageCount,
    dataReturned: state.themesPage.dataReturned,
    themes: state.themesPage.themes,
    query: state.themesPage.query,
    errorMessage: checkPermission('theme_management', state.profile)
      ? ''
      : 'You do not have the relevant permissions to view themes',
    themeManagementPerm: checkPermission('theme_management', state.profile),
    checkPermission: (permission) => checkPermission(permission, state.profile),
    checkPlanPermission: (permission) => checkPlanPermission(permission, state.profile),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getTeamThemes: (team, division, query, deleted, paths, checkPermission, page, pageSize) =>
    dispatch(getTeamThemes({ team, division, query, deleted, paths, checkPermission, page, pageSize })),
  set: (params) => dispatch(setAction(params)),
  showPaidPlanModal: () =>
    dispatch(
      setAppAction({
        isPaidPlanModalOpen: true,
      })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemesPage);
